import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/* VARIANTS */
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const gridVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const cardVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const contentVariant = {
  hidden: { height: 0, opacity: 0 },
  visible: {
    height: "auto",
    opacity: 1,
    transition: { duration: 0.4, ease: "easeOut" },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
};

const IndustryUseCase = ({ title, description, items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="industry-accordion-section">
      <motion.div
        className="industry-accordion-container"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* TOP CONTENT */}
        <div className="industry-accordion-header">
          <motion.h2
            className="section-title"
            variants={fadeUp}
          >
            {title}
          </motion.h2>

          <motion.p
            className="industry-accordion-desc"
            variants={fadeUp}
          >
            {description}
          </motion.p>
        </div>

        {/* ACCORDION GRID */}
        <motion.div
          className="industry-accordion-grid"
          variants={gridVariant}
        >
          {items.map((item, index) => {
            const isActive = activeIndex === index;

            return (
              <motion.div
                className={`industry-accordion-card ${
                  isActive ? "active" : ""
                }`}
                key={index}
                variants={cardVariant}
              >
                <button
                  className="industry-accordion-title"
                  onClick={() => toggleItem(index)}
                  aria-expanded={isActive}
                >
                  <h3 className="industry-accordion-heading">
                    {item.heading}
                  </h3>

                  <motion.span
                    className="industry-accordion-icon"
                    animate={{ rotate: isActive ? 180 : 0 }}
                    transition={{ duration: 0.25 }}
                  >
                    {isActive ? "−" : "+"}
                  </motion.span>
                </button>

                <AnimatePresence initial={false}>
                  {isActive && (
                    <motion.div
                      className="industry-accordion-content"
                      variants={contentVariant}
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                    >
                      <p>{item.text}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default IndustryUseCase;
